<div class="confirmation-modal">
    <owc-modal-dialog #modalDialogElement disable-backdrop-click [visible]="true">
        <div class="modal-content">
            <owc-typography class="heading">
                {{data.HEADER}}
            </owc-typography>
            <owc-typography class="desc" *ngFor="let para of data.DESC">
                {{ para }}
            </owc-typography>
        </div>
        <owc-component-footer slot="footer">
            <div slot="suffix" class="modal-footer">
                <owc-button data-testid="confirmation-close-btn" (click)="onClose()">
                    {{data.CLOSE_BTN || 'Close'}}
                </owc-button>
            </div>
        </owc-component-footer>
    </owc-modal-dialog>
</div>
